import React from "react";
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { Container } from "@mui/material";
import { ShowList } from "./ShowList";
import { ShowForm } from "./ShowForm";
import { ShowDetails } from "./ShowDetails";
import { ShowCalendar } from "./ShowCalendar";

const ShowDetailsRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: `/shows/${id}`, search, hash }} replace />;
};

export const ShowsPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Routes>
        <Route path="/" element={<ShowList />} />
        <Route path="/calendar" element={<ShowCalendar />} />
        <Route path="/new" element={<ShowForm />} />
        <Route path="/:id" element={<ShowDetails />} />
        <Route path="/:id/legacy" element={<ShowDetailsRedirect />} />
        <Route path="/:id/edit" element={<ShowForm />} />
        <Route path="*" element={<Navigate to="/shows" replace />} />
      </Routes>
    </Container>
  );
};
